import { clsx } from 'clsx'

import type { Space } from '@tribeplatform/gql-client/types'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

interface Props {
  space: Space
  indentation?: boolean
}
export const SpaceItem = ({ space, indentation }: Props) => {
  const { Link } = useRouter()

  return (
    <NavVertical.Item
      as={Link}
      href={`/manage/customizer/spaces/${space.id}/blocks`}
      leadingAddon={
        <div className={clsx('me-3', indentation && '-ms-1')}>
          <SpaceImage space={space} size="lg" />
        </div>
      }
      className={clsx(indentation && 'ps-9')}
    >
      <div className="truncate">
        {space.name}
        {space.private && <SvgIcon name="lock" className="ms-1" inline />}
      </div>
    </NavVertical.Item>
  )
}
